import { useLanguage } from "@/contexts/LanguageContext";

export default function Faq() {
  const { t } = useLanguage();

  return (
    <section id="faq" className="py-20 px-6 border-b border-white/10 max-w-4xl mx-auto" data-testid="faq-section">
      <div className="text-center mb-12">
        <span className="text-xs font-mono-code text-[#E2C079] uppercase tracking-widest block mb-2">{t.faq.eyebrow}</span>
        <h2 className="font-serif-didot text-3xl text-white">{t.faq.title}</h2>
      </div>
      <div className="space-y-4">
        {t.faq.items.map((item, i) => (
          <details
            key={item.q}
            className="rounded border border-white/10 bg-[#0f1b29]/60 p-5 cursor-pointer group"
            data-testid={`faq-item-${i}`}
          >
            <summary className="flex items-center justify-between font-semibold text-sm text-white">
              <span>{item.q}</span>
              <span className="text-xl text-[#E2C079] group-open:rotate-45 transition-transform ml-4">+</span>
            </summary>
            <p className="text-white/60 text-xs leading-relaxed mt-4">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
